import { inject, Injectable } from '@angular/core';import { UseCase } from '@shared/helper';
import { CreateOrderAffiliateDto, CreateOrderAffiliateResp } from './create-order-affiliate.interface';
import { catchError, Observable, throwError } from 'rxjs';
import { CheckoutRepository } from '@data/repositories/checkout.repository';
import { ErrorMessageService } from '@shared/services/error-message/error-message.service';

@Injectable({
    providedIn: 'root'
})

export class CreateOrderAffiliateUsecase implements UseCase<CreateOrderAffiliateDto, CreateOrderAffiliateResp> {
    private readonly checkoutRepository = inject(CheckoutRepository);
    private readonly errorMessageService = inject(ErrorMessageService);

    execute(params: CreateOrderAffiliateDto): Observable<CreateOrderAffiliateResp> {
        return this.checkoutRepository.CreateOrderAffiliate(params).pipe(
            catchError((error)=> {
                const {status_code, msisdn} = error;
                return throwError(()=> this.errorMessageService.getErrorMessage(status_code, msisdn));
            })
        );
    }
}